/**
 * PORTED — RO-3-00 / #44398.
 * Origin: `excellent/app/market/_client.tsx` (verbatim, minus the inert
 * `"use client"`). Renamed on the way in: `_client.tsx` said "the client half of
 * the page next door", which stops being true once it is a shared module reached
 * from 13 root pages across 5 sections. Both exports keep their names.
 *
 * All three ops (`market.runAnalysis`, `market.actFinding`, `market.dismissFinding`)
 * are already mounted on the Hono host, so this works at runtime here today.
 */

import { useState, useTransition } from "react";
import { Button } from "@excellent/ui";
import { apiCall } from "@excellent/ui/api";
import { market } from "@excellent/ui/api/contracts/market";

export function RunAnalysisButton({
  running,
  label = "Run analysis",
}: {
  running: boolean;
  label?: string;
}) {
  const [pending, start] = useTransition();
  const [msg, setMsg] = useState<string | null>(null);
  return (
    <div className="flex items-center gap-2">
      {msg ? <span className="type-subtext text-muted-foreground">{msg}</span> : null}
      <Button
        size="sm"
        disabled={pending || running}
        onClick={() =>
          start(async () => {
            const res = await apiCall(market.runAnalysis, { body: { kind: "full" } });
            setMsg(
              res.ok
                ? "Analyst launched — competitors & findings will appear shortly."
                : res.error ?? "Could not start analysis",
            );
          })
        }
      >
        {running ? "Analysis running…" : pending ? "Starting…" : label}
      </Button>
    </div>
  );
}

export function FindingActions({ id, hasFix }: { id: number; hasFix: boolean }) {
  const [pending, start] = useTransition();
  const [done, setDone] = useState<string | null>(null);
  if (done) return <span className="type-subtext text-muted-foreground">{done}</span>;
  return (
    <div className="flex items-center gap-2">
      {hasFix ? (
        <Button
          size="sm"
          variant="outline"
          disabled={pending}
          onClick={() =>
            start(async () => {
              const res = await apiCall(market.actFinding, { params: { id } });
              setDone(res.ok ? "Agent acting…" : res.error ?? "Failed");
            })
          }
        >
          Act with agent
        </Button>
      ) : null}
      <Button
        type="button"
        variant="ghost"
        size="sm"
        disabled={pending}
        onClick={() => start(async () => {
          await apiCall(market.dismissFinding, { params: { id } });
          setDone("Dismissed");
        })}
      >
        Dismiss
      </Button>
    </div>
  );
}
